import React, { Component } from "react";
import Datetime from "react-datetime";

/**
 * props:
 *  - Boolean editMode
 *  - Date    initialValue
 *  - Boolean currentValueValid
 *  - String  label
 *  - function handleChange
 *  - String stateKey Key for this datetime in the component state.
 **/
const Datepicker = (props) => {
  /**
   * A wrapper is needed for the change handler,
   * to add the key which should be updated in the parent
   * component's state.
   **/
  const handleChange = (moment) => {
    props.handleChange(props.stateKey, moment);
  };

  /**If this is a required field, shows a red asterisk next to the label**/
  const required_span =
    props.required && props.editMode ? (
      <span className="text-danger font-weight-bold">*</span>
    ) : (
      ""
    );

  let date_time = props.editMode ? (
    <Datetime
      initialValue={props.initialValue}
      onChange={handleChange}
      inputProps={
        props.currentValueValid
          ? {
              id: props.stateKey,
            }
          : {
              id: props.stateKey,
              className: "alert-danger w-100",
            }
      }
    />
  ) : (
    ""
  );

  let timezones = (
    <div className={props.editMode ? "alert alert-secondary" : "card p-3 "}>
      {props.initialValue ? generateTimeZones(props.initialValue) : ""}
    </div>
  );
  return (
    <div>
      <label>
        {props.label}: {required_span}
      </label>
      {date_time}
      {timezones}
    </div>
  );
};

const generateTimeZones = (date) => {
  let cairo_opts = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short",
    timeZone: "Africa/Cairo",
  };
  let ny_opts = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short",
    timeZone: "America/New_York",
  };
  let la_opts = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short",
    timeZone: "America/Los_Angeles",
  };
  return (
    <div className="time-zones">
      <div
        className="cairo-time"
        title={date.toLocaleString("ar-EG", cairo_opts)}
      >
        {date.toLocaleString("en-US", cairo_opts)}
      </div>
      <div
        className="new-york-time"
        title={date.toLocaleString("ar-EG", ny_opts)}
      >
        {date.toLocaleString("en-US", ny_opts)}
      </div>
      <div
        className="los-angeles-time"
        title={date.toLocaleString("ar-EG", la_opts)}
      >
        {date.toLocaleString("en-US", la_opts)}
      </div>
    </div>
  );
};

export default Datepicker;
